<template>
<!-- <img src="../assets/about_us.png" alt=""> -->
<div class="bg">
  <section class="flex">
      <div class="container-1">
      <h3>ABOUT US</h3>
      <h1>We love teaching <br> kids, the art of yoga</h1>
      </div>
      <div class="container-2">
      <h4>Through our creatively designed and carefully curated classes, <br> the kids will learn yoga, breathwork, philosophy, values and <br> meditation. We use an engaging mix of storytelling, games, <br> music, themes, challenges and more to really get the juices <br> flowing. </h4>
      <button>Learn more</button>
      </div>
      
  </section>
  <section class="flex2">
      <div class="container-1">
      <h3>MISSION</h3>
      <h4>Making yoga a playful and engaging activity, <br> giving kids usable tools for everyday stress, <br> worries and challenges.</h4>
      </div>
      <div class="container-2 vision">
      <h3>VISION</h3>
      <h4>Beginning with kids as young as three, we <br> envision the deep yoga tradition becoming <br> popular with all kids. We want to give each <br> and every child access to yoga and its benefits <br> so that they deeply enjoy it.</h4>
      </div>
  </section>
 

  <div class="impact">
      <div class="title">
      <h3 class="far">OUR IMPACT SO FAR</h3>
      </div>
      <div class="flexboxes">
      <div class="box1">
          <img src="../../assets/comma.png" alt="">
          <h1>8</h1>
          <h4>Countries Reached</h4>

      </div>
      <div class="box2">
          <img src="../../assets/comma.png" alt="">
          <h1>8</h1>
          <h4>Poses Taught</h4>

      </div>
      <div class="box3">
          <img src="../../assets/comma.png" alt="">
          <h1>8</h1>
          <h4>Kids reached Online</h4>

      </div>
      <div class="box4">
          <img src="../../assets/comma.png" alt="">
          <h1>8</h1>
               <h4>Kids reached Offline</h4>


      </div>
      </div>
      
  </div>
   </div>

</template>

<script>
export default {

}
</script>

<style scoped>
.vision{
    margin-right: 176px;
}
.far{
padding-left: 308px;
}

h4{
    color: white;
    font-weight: 500;
    line-height: 150%;
    padding-bottom: 34px;
}
h3{
    color: #791E94;
    font-weight: 450;
}

h1{
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: white;
}

.bg{
 background: url("../../assets/about_us.png");
    min-height: 190vh;
    background-repeat: no-repeat;
    /* object-fit: cover; */
    /* background-size: cover; */
    background-position: inherit;
    background-position-x: -355px;
    /* height: 100vh; */
    margin-top: 100px;
    background-size: cover;
}
.impact{
    position: relative;
    top: 499px;
}

.flex{
    display: flex;
    justify-content: space-around;
    padding-top: 50px;
        width: 100%;
            position: relative;
  top: 478px;
      width: 80%;
    margin: auto;
    flex-wrap: wrap;
}
.flex2{
    display: flex;
    justify-content: space-around;
    padding-top: 50px;
    position: relative;
    top: 496px;
    width: 92%;
    margin: auto;
    flex-wrap: wrap;
}
.box1, .box2, .box3, .box4{
    height: 250px;
    width: 232px;
    background-color: #4BA3C3;
    color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 30px;
}
img{
        position: relative;
    left: -76px;
    top: 19px;
}
.flexboxes{
    display: flex;
    justify-content: space-evenly;
    padding-top: 12px;
        width: 80%;
    margin: auto;
}
button{
     color: white;
    background-color: transparent;
    border: none;
    padding: 15px 60px;
    border-radius: 10px;
    cursor: pointer;
    border: 2px solid #791E94;
    transition: 0.3s ease-in;

}
button:hover{
    background-color: #791E94;
}
/* .impact{
    display: flex;
    align-items: center;
    flex-direction: column;
} */


@media (max-width: 1080px) {
    .bg{
 width: 100%;
  height: auto;
  background-position-x: -514px;
    }

    .flexboxes{
flex-wrap: wrap;
    }
}


@media (max-width: 1200px){
    .flex{
        height: 552px;
        position: unset;
        min-height: 684px;
    }
    .flex2{
        position: unset;
        padding-top: 0px;
    }
    .impact{
        position: unset;
    }
    .bg{
        
        min-height: 1252px;
        background: none;
        background-color: #F0A201;
    }
    .far{
            text-align: center;
            padding-left: 0px;
            margin-top: 75px;
    }
    .title{
        text-align: center;
    }

    @media (max-width: 1070px){
        /* .bg{
             height: 1488px;
        } */
    }
}
</style>